import { Box, Button, Typography } from "@mui/material";
type ButtonTypes = {
  onSubmit: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onReset: (e: React.MouseEvent<HTMLButtonElement>) => void;
  loading: boolean;
};
export default function ResetSubmitButton({
  onSubmit,
  onReset,
  loading = false,
}: ButtonTypes) {
  return (
    <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
      <Button
        variant="outlined"
        onClick={onReset}
        sx={{
          px: 4,
          py: 1.2,
          fontWeight: 600,
          borderColor: "#fcb500",
          color: "#fcb500",
          "&:hover": {
            backgroundColor: "#fff8e1",
            borderColor: "#fcb500",
          },
        }}
      >
        Reset
      </Button>
      {loading ? (
        <Typography>Please wait...</Typography>
      ) : (
        <Button
          variant="contained"
          onClick={onSubmit}
          sx={{
            px: 4,
            py: 1.2,
            backgroundColor: "#fcb500",
            color: "#000",
            fontWeight: 600,
            "&:hover": {
              backgroundColor: "#fbc02d",
            },
          }}
        >
          Save
        </Button>
      )}
    </Box>
  );
}
